<template>
    <div id="MemberInfo">
        <YD-dialog :show.sync="memberInfoShow" :close-click-modal="false" @close-animation-end="reset">
            <div class="dialog">
                <div class="memberInfo_header">
                    <div class="memberInfo_title">
                        <span>参赛人员信息</span>
                        <YD-image src="icon/icon_dialog_close" class="close" @click.native="close"></YD-image>
                    </div>
					<div class="enrollGroup_hint" v-if="isEnrollGroup">
						<span>温馨提示：</span>该队员已在其他代表队中担任运动员，只能在此担任其他人员，且不能修改其报名信息。
					</div>
                    <div class="memberInfo_tab">
                        <ul>
                            <li :class="{
                                'active': tabIndex == 0,
                                'new': groupNew
                            }" @click="selectTab(0)"><span>报名组别</span></li>
                            <li :class="{'active': tabIndex == 1}" @click="selectTab(1)"><span>人员身份</span></li>
                            <li :class="{'active': tabIndex == 2}" @click="selectTab(2)"><span>基本信息</span></li>
                        </ul>
                    </div>
                </div>
                <div class="memberInfo_content">
                    <div class="memberInfo_group" v-show="tabIndex == 0">
                        <Option :active="isNoGroup"
                            @click="selectGroup(1)"
                        >暂不选组</Option>
                        <Option v-for="(item,index) in groups" :key="index"
                            disabledTrigger
                            :checkbox="!isNoGroup"
                            :active="getGroupActive(item)"
                            :disabled="getGroupDisabled(item) > 0"
                            @click="selectGroup(2,item)"
                        >{{item.GroupSetting.LeagueGroupName}}</Option>
                    </div>
                    <div class="memberInfo_role" v-show="tabIndex == 1">
                        <template v-for="(item,index) in roles">
                            <template v-if="item.children">
                                <Option :key="'a' + index" 
                                    checkbox
                                    :active="getRoleChildrenActive(item.children)"
                                    @click="selectRole(item.children[0])"
                                >{{item.name}}</Option>
                                <div class="children" :key="'b' + index" v-show="getRoleChildrenActive(item.children)">
                                    <Option v-for="(CItem,CIndex) in item.children" :key="CIndex"
                                        checkbox
                                        :active="getRoleActive(CItem)"
                                        @click="selectRole(CItem)"
                                    >{{CItem.RoleName}}</Option>
                                </div>
                            </template>
                            <template v-else>
                                <Option :key="index" 
                                    disabledTrigger
                                    checkbox
                                    :active="getRoleActive(item)"
                                    :disabled="getRoleDisabled(item)"
                                    @click="selectRole(item)"
                                >{{item.RoleName}}</Option>
                            </template>
                        </template>
                    </div>
                    <div class="memberInfo_basic" v-show="tabIndex == 2">
						<div class="realName_hint" v-if="isRealName">
							该队员<span>已实名认证</span>，报名信息中的个人信息不可修改。
						</div>
                        <div class="phone">
							<div class="content">
								<span class="label">手机号</span>
								<span class="text">{{form.phone}}</span>
							</div>
                            <button v-href="phoneUrl" v-if="!isRealName && !isEnrollGroup">修改</button>
                        </div>
                        <Fold label="1.证件类型" 
                            :text="cardInfo.name" 
                            :unfold="unfoldName == 'identityType'" 
                            :error="errorUnfold == 'identityType'" 
                            :required="isAthlete && fieldsOptions.identity_limit == 1 || fieldsOptions.identity_limit == 9"
                            @unfold-change="unfoldChange(...arguments, 'identityType')" 
                        >
                            <div>
                                <Option v-for="(item,index) in identityTypeList" :key="index"
                                    :active="form.identityType == item.type" :disabled="isRealName || isEnrollGroup"
                                    @click="selectIdentityType(item.type)">{{item.name}}</Option>
                            </div>
                        </Fold>
                        <Fold label="2.证件号" 
                            :text="form.identityNo" 
                            :unfold="unfoldName == 'identityNo'" 
                            :error="errorUnfold == 'identityNo'" 
                            :required="isAthlete && fieldsOptions.identity_limit == 1 || fieldsOptions.identity_limit == 9"
                            @unfold-change="unfoldChange(...arguments,'identityNo')" 
                        >
                            <Input v-model.trim="form.identityNo" :focus="unfoldName == 'identityNo'" :disabled="isRealName || isEnrollGroup" placeholder="请输入证件号" :maxlength="cardInfo.len || 18" @input="identityNoChange"></Input>
                        </Fold>
                        <Fold label="3.性别" 
                            :text="['男','女'][form.sex - 1]" 
                            :unfold="unfoldName == 'sex'" 
                            :error="errorUnfold == 'sex'" 
                            :required="isAthlete && fieldsOptions.sex_limit == 1 || fieldsOptions.sex_limit == 9"
                            @unfold-change="unfoldChange(...arguments,'sex')" 
                        >
                            <template v-if="form.identityType == 1 && (fieldsOptions.identity_limit == 1 && isAthlete || fieldsOptions.identity_limit == 9 || !!form.identityNo) || isRealName || isEnrollGroup">
                                <Option :active="form.sex == 1" disabled key="a1">男</Option>
                                <Option :active="form.sex == 2" disabled key="a2">女</Option>
                            </template>
                            <template v-else>
                                <Option :active="form.sex == 1" @click="sexChange(1)" key="b1">男</Option>
                                <Option :active="form.sex == 2" @click="sexChange(2)" key="b2">女</Option>
                            </template>
                        </Fold>
                        <Fold label="4.出生日期" 
                            :text="form.birthDate" 
                            :unfold="unfoldName == 'birthDate'" 
                            :error="errorUnfold == 'birthDate'" 
                            :required="isAthlete && fieldsOptions.birthday_limit == 1 || fieldsOptions.birthday_limit == 9"
                            @unfold-change="unfoldChange(...arguments,'birthDate')" 
                        >
                            <template v-if="form.identityType == 1 && (fieldsOptions.identity_limit == 1 && isAthlete || fieldsOptions.identity_limit == 9 || !!form.identityNo) || isRealName || isEnrollGroup">
                                <Option disabled key="1">{{form.birthDate || "选择日期"}}</Option>
                            </template>
                            <template v-else>
                                <Option @click="setDate()" key="2">{{form.birthDate || "选择日期"}}</Option>
                            </template>
                        </Fold>
                        <template v-if="isAthlete">
                            <Fold label="5.球衣号码" 
                                :text="form.jerseyNumber" 
                                :unfold="unfoldName == 'jerseyNumber'" 
                                :error="errorUnfold == 'jerseyNumber'" 
                                :required="true"
                                @unfold-change="unfoldChange(...arguments,'jerseyNumber')" 
                                v-if="fieldsOptions.jersey_number"
                            >
                                <Input 
                                    type="tel" pattern="\d*" 
                                    v-model.trim="form.jerseyNumber" 
                                    :focus="unfoldName == 'jerseyNumber'" 
                                    placeholder="请输入球衣号码" 
                                    :maxlength="2"
                                ></Input>
                            </Fold>
                        </template>    
                        <template v-if="ExtraDataDefines.length">
                            <template v-for="(item,index) in ExtraDataList">
                                <Fold :key="item.Field" :label="`${(fieldsOptions.jersey_number ? 5: 4) + (index + 1)}.${item.Name}`" 
                                    :text="extraForm[item.Field]" 
                                    :unfold="unfoldName == item.Field" 
                                    :error="errorUnfold == item.Field" 
                                    :required="item.Mandatory"
                                    @unfold-change="unfoldChange(...arguments,item.Field)" 
                                >
                                    <template v-if="item.DataType == 'Text'">
                                        <Input :type="item.Precision ? 'textarea' : ''"
                                            :focus="unfoldName === item.Field" 
                                            v-model.trim="extraForm[item.Field]" 
                                            :placeholder="item.InputTips || `请输入${item.Name}`" 
                                            :maxlength="item.Max"
                                            :disabled="isEnrollGroup"
                                            @input="textInput"></Input>
                                    </template>
                                    <template v-else-if="item.DataType == 'Integer'">
                                        <Input type="number"
                                            :focus="unfoldName === item.Field" 
                                            integer
                                            v-model.number="extraForm[item.Field]"
                                            :placeholder="item.InputTips || `请输入${item.Name}`" 
                                            :disabled="isEnrollGroup"
                                            @input="textInput"></Input>
                                    </template>
                                    <template  v-else-if="item.DataType == 'Number'">
                                        <Input type="number"
                                            :focus="unfoldName === item.Field" 
                                            v-model.number="extraForm[item.Field]"
                                            :placeholder="item.InputTips || `请输入${item.Name}`"
                                            :disabled="isEnrollGroup"
                                            @input="textInput"></Input>
                                    </template>
                                    <template v-else-if="item.DataType == 'Enum'">
                                        <div class="extra_select">
                                            <Option 
                                                :lineNumber="2"
                                                v-for="(option, optionIndex) in item.Values" 
                                                :key="optionIndex"
                                                :active="extraForm[item.Field] == option"
                                                :disabled="isEnrollGroup"
                                                @click="selectClick(item.Field, option)"
                                            >{{option}}</Option>
                                        </div>
                                    </template>
                                    <template v-else-if="['DateTime', 'Date'].includes(item.DataType)">
                                        <Input type="text"
                                            :value="extraForm[item.Field]"
                                            :placeholder="item.InputTips || `请选择${item.Name}`"
                                            :disabled="isEnrollGroup"
                                            readonly="readonly" @click="selectDateTime(item)"></Input>
                                    </template>
                                </Fold>
                            </template>
                        </template>
                        <div class="upload_images_title">
                            <div class="title">请上传{{cardInfo.name}}</div>
                            <div class="desc">{{cardInfo.text}}（非必填）</div>
                        </div>
                        <div class="upload_images">
                            <div class="image_item front" @click="uploadImg(1)">
                                <img src="@images/身份证_正面@2x.png" v-show="!form.frontImg" class="default">
                                <img :src="form.frontImg" v-show="form.frontImg" class="image">
                            </div>
                            <div class="image_item behind" @click="uploadImg(2)">
                                <img src="@images/身份证_反面@2x.png" v-show="!form.behindImg" class="default">
                                <img :src="form.behindImg" v-show="form.behindImg" class="image">
                            </div>
                        </div>
                        <div class="upload_images_title">
                            <div class="title">请上传免冠大头照</div>
                            <div class="desc">
                            <template v-if="(fieldsOptions.portrait_photo == 1 && isAthlete) || fieldsOptions.portrait_photo == 9">用于制作比赛秩序册（必填）</template>
                            <template v-else>非必填</template>
                            </div>
                        </div>
                        <div class="upload_images">
                            <div class="image_item portrait" @click="showUploadPortraitPhoto()">
                                <img src="@images/肖像@2x.png" v-show="!form.portraitImg" class="default">
                                <img :src="form.portraitImg" v-show="form.portraitImg" class="image">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="memberInfo_option">
                    <button @click="submit">保存</button>
                </div>
            </div>
        </YD-dialog>
        <Datetime-picker ref="datePicker" v-bind="datePickerConfig" @change="datePickerChange"></Datetime-picker>
        <UploadPortraitPhoto ref="uploadPortraitPhoto" :ossConfig="ossOptions"></UploadPortraitPhoto>
    </div>
</template>
<script>
import Fold from './Fold.vue';
import Input from './Input.vue';
import Option from './Option.vue';
import DatetimePicker from '@/components/datetime-picker/main.vue';
import UploadPortraitPhoto from '@/components/UploadPortraitPhoto.vue';

import { 
    dateFormat,
    identityCard
} from '@js';
import {
    updatePortrait
} from '@js/appInteraction';
import {
    GetUserEnrollCanJoinGroupList,
    GetUserEnrollAllRoleList,//获取所有身份
    EditDeputationEnrollUser,
    GetLeagueEnrollFieldsOptions,
    GetUserRegisInfo,
    GetDeputationEnrollUserIsEnrollGroupInOtherDpt
} from '@/api';
import extra from '@/mixins/extra';
import formValidator from '@/common/formValidator';
export default {
    name:"MemberInfo",
    components:{
        Fold,
        Input,
        Option,
        DatetimePicker,
        UploadPortraitPhoto
    },
    mixins: [extra],
    props:{
        show: Boolean,
        subLeagueId: Number,
        deputationEnrollId: Number,
        memberInfo:{
            type:Object,
            required: true
        },
        ossOptions:{
            type:Object,
            required: true
        }
    },
    data(){
        return {
            memberInfoShow: false,
            tabIndex: 0,
            groupNew: false,
            unfoldName: '',
            errorUnfold: '',
            isRealName: false,
            form:{
                phone: "",
				identityType: 1,
				identityNo: "",
				sex: 0,
				birthDate: "",
                roleValue: [],
                groupValue: [],
                jerseyNumber: "",
                frontImg: "",
                behindImg: "",
                portraitImg: ""
            },
			fieldsOptions: {},
            jerseyNumberBlur: true,
            enrollOptions: {},
            oldRoleValue:[],
            oldGroupValue:[],
            roles:[],
            groups: [],
            isDataUpdate: false,
            datePickerConfig: {},
            isEnrollGroup: false
        }
    },
    created(){
        GetLeagueEnrollFieldsOptions({
            SubLeagueId: this.subLeagueId
        }).then(data=>{
            if(data.Code == 0){
                this.fieldsOptions = data.FieldsOptions;
                this.initExtraForm(data.ExtraDataDefines);
                this.enrollOptions = data.EnrollOptions;
            }
        })
    },
    activated(){
        if(sessionStorage.getItem('updatePhone')){
            this.form.phone = sessionStorage.getItem('updatePhone');
            sessionStorage.removeItem('updatePhone');
        }
    },
    watch:{
        show(newVal){
            this.memberInfoShow = newVal;
        },
        memberInfoShow(newVal){
            if(newVal){
                this.init();
            }else{
                this.$emit('update:show',false);
				setTimeout(()=>{
					this.reset();
				}, 200)
            }
        },
        groups:{
            deep:true,
            handler(newVal){
                this.groups = newVal || [];
            }
        },
		'form.sex'(){
			if(!this.memberInfoShow) return;
			this.getGroupList();
		},
		'form.birthDate'(){
			if(!this.memberInfoShow) return;
			if(this.form.identityType != 1 || !this.form.identityNo){
				this.getGroupList();
			}
		},
        'form.groupValue'(){
            if(this.tabIndex != 0){
                this.groupNew = true;
            }
        }
    },
    computed:{
        identityTypeList(){
            return [
                {
                    name: '身份证（港澳台居住证）',
                    text:"二代身份证（港澳台居住证）正反面照片",
                    type: 1,
                    len: 18
                },
                // {
                //     name:'护照',
                //     text:"个人信息页",
                //     type:2,
                //     len: 9,
                //     RegEx:/^[a-zA-Z0-9]{9}$/
                // },
                // {
                //     name:'台湾居民来往大陆通行证',
                //     text:"个人信息页",
                //     type:4,
                //     len: 8,
                //     RegEx:/^\d{8}$/
                // },
                // {
                //     name:'港澳居民来往内地通行证',
                //     text:"个人信息页",
                //     type:5,
                //     len: 9,
                //     RegEx:/^(H|M)\d{8}$/
                // }
            ]
        },
        phoneUrl(){
			return `'/Enroll/MemberUpdatePhone?phone=${this.form.phone}&id=${this.memberInfo.UserId}`;
		},
		cardInfo(){
            let obj = this.identityTypeList.find(item=>item.type == this.form.identityType) || {};
            return obj;
		},
        isAthlete(){
            return this.form.roleValue.some(item=>item.IsAthlete == 1);
        },
		isNoGroup(){
			return this.form.groupValue.length == 0;
		},
		rules(){
			return {
				identityType: (value, callback)=>{
					if(!value && (this.isAthlete && this.fieldsOptions.identity_limit == 1 || this.fieldsOptions.identity_limit == 9)){
						callback('请选择证件类型');
					}
					callback();
				},
				identityNo: (value, callback)=>{
					if(!value){
						if(this.isAthlete && this.fieldsOptions.identity_limit == 1 || this.fieldsOptions.identity_limit == 9){
							callback('请输入证件号');
						}
					}else if(this.form.identityType == 1){
						let info = identityCard(value);
						if(!info){
							callback('证件号格式有误');
						}else{
							let y = new Date(info.dateBirth).getFullYear();
							if(y < 1900 || y > new Date().getFullYear()){
								callback(y < 1900 ? '证件号年份不能小于1900' : '证件号出生年份不能大于当前年份');
							}
						}
					}else if(this.form.identityType != 1 && (value.length != this.cardInfo.len || !value.match(this.cardInfo.RegEx))){
						callback('证件号格式有误');
					}
					callback();
				},
				sex: (value, callback)=>{
					if(!value && (this.isAthlete && this.fieldsOptions.sex_limit == 1 || this.fieldsOptions.sex_limit == 9)){
						callback('请选择性别');
					}
					callback();
				},
				birthDate: (value, callback)=>{
					if(!value && (this.isAthlete && this.fieldsOptions.birthday_limit == 1 || this.fieldsOptions.birthday_limit == 9)){
						callback('请选择出生日期');
					}
					callback();
				},
				roleValue: (value, callback)=>{
					if(value.length == 0){
						callback('请选择身份');
					}
					callback();
				},
				groupValue: (value, callback)=>{
					let {
						athlete_enroll_limit
					} = this.enrollOptions;
					if(value.length > 0 && athlete_enroll_limit == 1){
						let is = value.some(item=>{
							let obj = this.groups.find(groupItem=>item.GroupInfo.Id == groupItem.GroupSetting.LeagueGroupId);
							if(obj && obj.GroupSetting.GroupType == 2){
								return true;
							}
						})
						if(!is){
							callback('必须先报名团体组别，才能报名个人/双人组别');
						}
					}
					callback();
				},
				jerseyNumber: (value, callback)=>{
					if(this.isAthlete && this.fieldsOptions.jersey_number){
						if(!value){
							callback('请输入球衣号码');
						}else if(value < 0 || value > 99){
							callback('请输入0~99的球衣号码');
						}
					}
					callback();
				},
				portraitImg: (value, callback)=>{
					if(!value && (this.fieldsOptions.portrait_photo == 1 && this.isAthlete || this.fieldsOptions.portrait_photo == 9)){
						callback('请上传照片');
					}
					callback();
				}
			}
		}
    },
    methods:{
        unfoldChange(e, unfold, unfoldName){
            if(!unfold){
                this.unfoldName = '';
            }else{
                this.unfoldName = unfoldName;
            }
        },
		setDataUpdate(){
			this.isDataUpdate = true;
		},
		//通用 Text
		textInput(){
			this.setDataUpdate();
		},
		//通用 Enum
		selectClick(formKey, value){
			let oldVal = this.extraForm[formKey];
			if(value != oldVal){
				this.extraForm[formKey] = value;
				this.setDataUpdate();
			}
		},
		//通用 Date
		selectDateTime(item){
			let {
				Field,
				Min,
				Max,
                DataType
			} = item;
            let {
                format,
                datePickerType
            } = this.getDateFormat(DataType);
			let date = dateFormat(this.extraForm[Field] || new Date(), format);
			let config = {
                type: datePickerType,
				value: date,
				min: dateFormat(Min || '1970-1-1 00:00:00', format),
				max: dateFormat(Max || '2099-12-31 23:59:59', format),
				formKey: Field,
                DataType
			}
            this.datePickerConfig = config;
            this.$refs.datePicker.show();
		},
		//通用 Date
		datePickerChange(value){
			let formKey = this.datePickerConfig.formKey;
			if(!formKey) return;
            if(formKey == 'birthDate'){
                this.$set(this.form, 'birthDate', dateFormat(new Date(value),'yyyy-MM-dd'));
			    this.setDataUpdate();
            }else{
                let { format } = this.getDateFormat(this.datePickerConfig.DataType);
                value = dateFormat(value, format);
                let oldVal = this.extraForm[formKey];
                if(value != oldVal){
                    this.extraForm[formKey] = value;
                    this.setDataUpdate();
                }
            }
		},
        reset(){
            this.tabIndex = 0;
			this.groupNew = false;
            this.form = {
                phone: "",
				identityType: 1,
				identityNo: "",
				sex: 0,
				birthDate: "",
                roleValue: [],
                groupValue: [],
                jerseyNumber: "",
                frontImg: "",
                behindImg: "",
                portraitImg: ""
            },
            this.roles = [];
            this.groups = [];
            this.isDataUpdate = false;
        },
        init(){
            let userInfo = {...this.memberInfo};
            this.unfoldName = '';
            this.isRealName = false;
            this.isEnrollGroup = false;
            this.getGroupList();
            if(userInfo.UserEnrollId > 0){
                let form = {};
                form.phone = userInfo.Phone;
				form.jerseyNumber = userInfo.JerseyNumber || "";
                form.groupValue = [...(userInfo.EnrollGroupList || [])];
                form.roleValue = [...(userInfo.EnrollRoleList || [])];
                this.form = form;
                this.oldGroupValue = [...form.groupValue];
                this.oldRoleValue = [...form.roleValue];
                this.initExtraForm(undefined, userInfo.Extras);
                this.getRoleList();
                this.$nextTick(function(){
                    this.isDataUpdate = false;
                })

                let loading = this.$Toast.loading('加载中');
                GetDeputationEnrollUserIsEnrollGroupInOtherDpt({
                    DeputationEnrollId: this.deputationEnrollId,
                    EnrollUserId: userInfo.UserId
                }).then(data=>{
                    loading.close();
                    if(data.Code == 0){
						this.isEnrollGroup = data.IsEnrollGroupInOtherDpt;
                    }
                })
				this.getUserRegisInfo(userInfo);
            }
        },
        /**
         * 设置信息到页面
         */
        setUserInfo(userInfo){
            if(!userInfo) return;
            let form = this.form;
            form.phone = userInfo.Phone;
            form.identityType = userInfo.IdentityType || 1;
            form.identityNo = userInfo.IdentityNo || "";
            form.frontImg = userInfo.IdentityPhoto1 || "";
            form.behindImg = userInfo.IdentityPhoto2 || "";
            form.portraitImg = userInfo.PortraitPhoto || "";
            if(userInfo.IdentityType == 1 && userInfo.IdentityNo){
                let info = identityCard(userInfo.IdentityNo);
                if(info){
                    form.sex = info.sex;
                    form.birthDate = dateFormat(new Date(info.dateBirth),'yyyy-MM-dd');
                }
            }else{
                form.sex = userInfo.Gender || 0;
                form.birthDate = userInfo.Birthday ? dateFormat(new Date(userInfo.Birthday),'yyyy-MM-dd') : "";
            }
            console.log(form);
			this.$set(this, 'form', {...form});
        },
		/**
		 * 获取用户信息
		*/
		getUserRegisInfo(userInfo){
			let {
				IdentityPhoto1, 
				IdentityPhoto2, 
				PhotolUrl
			} = userInfo;
			GetUserRegisInfo({
				QueryUserId: this.memberInfo.UserId,
			}).then(data => {
				if(data.Code == 0){
					let regisInfo = data.RegisInfo;
					this.isRealName = regisInfo.HasIdentitySuccess;
					if(this.isRealName){
						this.setUserInfo({
							...regisInfo, 
							IdentityPhoto1, 
							IdentityPhoto2, 
							PortraitPhoto: PhotolUrl
						});
					}else{
                        userInfo.Phone = regisInfo.Phone; //手机号可能已经更新
                        this.setUserInfo({
                            ...userInfo,
                            PortraitPhoto: PhotolUrl
                        });
					}
					this.$nextTick(function(){
						this.isDataUpdate = false;
					})
				}
			})
		},
        btnCallback(text){
            if(text == "保存"){
                this.submit();
            }else{
                this.memberInfoShow = false;
            }
            this.tipShow = false;
        },
        close(){
            if(this.isDataUpdate){
                this.$Prompt({
                    title: '温馨提示',
                    message: '您已修改此参赛人员信息是否保存',
                    showCancel: true,
					cancelText: '不保存',
                	confirmText: '保存',
                    showClose: true
                }).then(confirm=>{
					if(confirm){
						this.submit();
					}else{
						this.memberInfoShow = false;
					}
                })
            }else{
                this.memberInfoShow = false;
            }
        },
        selectTab(index){
            this.tabIndex = index;
            if(index == 0 && this.groupNew){
                this.groupNew = false;
            }
        },
        selectIdentityType(type){
            var identityType = this.form.identityType;
            if(identityType != type){
                this.$set(this.form, 'identityType', type);
                this.$set(this.form, 'identityNo', '');
                this.unfoldName = 'identityNo';
            }
        },
        identityNoChange(){
			let {
				identityType,
				identityNo
			} = this.form;
			if(identityType == 1 && identityNo.length == 18){
				let info = identityCard(identityNo);
				if (!info) {
                    this.$Toast.error('证件号格式有误');
					this.errorUnfold = 'identityNo';
				}else{
					let y = new Date(info.dateBirth).getFullYear();
					if(y < 1900 || y > new Date().getFullYear()){
                        this.$Toast.error(y < 1900 ? '证件号年份不能小于1900' : '证件号出生年份不能大于当前年份');
						this.errorUnfold = 'identityNo';
					}else{
                        this.$set(this.form, 'sex', info.sex);
                        this.$set(this.form, 'birthDate', dateFormat(new Date(info.dateBirth),'yyyy-MM-dd'));
					}
				}
			}else if(identityType == 1 && identityNo.length != 18){
                this.$set(this.form, 'sex', 0);
                this.$set(this.form, 'birthDate', '');
			}
			this.setDataUpdate();
		},
		sexChange(sex){
			if(this.form.sex != sex){
                this.$set(this.form, 'sex', sex);
			    this.setDataUpdate();
			}
		},
        setDate(){//出生日期
			let config = {
                type: 'date',
				value: dateFormat(this.form.birthDate, 'yyyy-MM-dd'),
				min: "1900-01-01",
				max: dateFormat(new Date(),'yyyy-MM-dd'),
				formKey: 'birthDate'
			}
            this.datePickerConfig = config;
            this.$refs.datePicker.show();
        },
        getRoleList(){
            GetUserEnrollAllRoleList({
                DeputationEnrollId: this.deputationEnrollId
            }).then(data=>{
                if(data.Code == 0){
                    let roleList = data.RoleList,
                        roles = [],
                        athletes = [];
                    for(var i=0;i<roleList.length;i++){
                        let obj = roleList[i];
                        if(obj.IsAthlete == 1){
                            athletes.push(obj);
                        }else{
                            roles.push(obj);
                        }
                    }
                    if(athletes.length > 1){
                        roles.push({
                            name: '运动员',
                            children: athletes
                        })
                    }else{
                        roles.push(...athletes);
                    }
                    this.roles = roles;
                    this.setRoleInfo(roleList);
                }
            })
        },
        setRoleInfo(roleList){
            var roleValue = this.form.roleValue,
                roles = [];
            if(roleList.length > 0 && roleValue.length > 0){
                for(var i=0;i<roleValue.length;i++){
                    let obj = roleValue[i];
                    let filterArr = roleList.filter(n=>n.RoleId == obj.RoleId);
                    if(filterArr.length > 0){
                        roles.push(filterArr[0]);
                    }
                }
                this.form.roleValue = roles;
            }
        },
        selectRole(obj){
            let roles = [...this.form.roleValue];
            if(this.getRoleDisabled(obj)){
                this.$Toast.warning('该身份已满员');
                return;
            }
            if(this.getRoleActive(obj)){
				let index = roles.findIndex(item=>item.RoleId == obj.RoleId)
				roles.splice(index, 1);
				if(obj.IsAthlete == 1){
					this.$set(this.form, 'groupValue', []);
				}
            }else{
                if(obj.IsAthlete == 1){
                    let index = roles.findIndex(item=>item.IsAthlete == 1);
					let notCanPartTime = roles.find(item=>item.CanPartTime == 0);
					if(index >= 0){
						roles.splice(index, 1);
						roles.push(obj);
					}else if(notCanPartTime){
						let {RoleName} = notCanPartTime;
                        this.$Toast.warning(RoleName+'不能兼报运动员');
						return;
					}else{
						roles.push(obj);
					}
                }else{
					let isAthlete = roles.some(item=>item.IsAthlete == 1);
                    if(isAthlete && obj.CanPartTime == 0){
                        this.$Toast.warning(RoleName+'不能兼报运动员');
                        return;
                    }else{
                        roles.push(obj);
                    }
                }
            }
            this.setDataUpdate();
            this.$set(this.form, 'roleValue', roles);
        },
        getRoleActive(obj){
            return this.form.roleValue.some(item=>item.RoleId == obj.RoleId);
        },
        getRoleChildrenActive(arr){
            return arr.some(item=>{
                return this.getRoleActive(item);
            });;
        },
        getRoleDisabled(obj){
            let isInclude = this.oldRoleValue.some(item=>item.RoleId == obj.RoleId);
            return !isInclude && !!obj.PeopleMax && obj.NowEnrollNum >= obj.PeopleMax;
        },
        getGroupList(){
            let Gender = this.form.sex;
            let Birthday = this.form.birthDate;
            GetUserEnrollCanJoinGroupList({
                DeputationEnrollId: this.memberInfo.DeputationEnrollId,
                Gender: Gender || null,
                Birthday: Birthday || null,
                QueryUserId: this.memberInfo.UserId
            }).then(data=>{
                if(data.Code == 0){
                    if(Gender != this.form.sex || Birthday != this.form.birthDate) return;
					let list = data.GroupList || [];
					this.groups = list;
					if(!this.isEnrollGroup){
						let groupValue = list.filter(groupItem=>
                            this.getGroupActive(groupItem) && this.getGroupDisabled(groupItem) == 0
                        ).map(groupItem=>{
							return {
                                GroupInfo: {
                                    Id: groupItem.GroupSetting.LeagueGroupId,
                                    Name: groupItem.GroupSetting.LeagueGroupName
                                }
							}
						});
						this.$set(this.form, 'groupValue', [...groupValue]);
					}else{
						this.$set(this.form, 'groupValue', []);
					}
                }
            })
        },
        selectGroup(type,obj){
            if(type == 1){
                this.$set(this.form,'groupValue',[]);
                return;
            }
			let groupValue = [...this.form.groupValue];
			if(this.getGroupActive(obj)){
				let index = groupValue.findIndex(item=>item.GroupInfo.Id == obj.GroupSetting.LeagueGroupId);
				groupValue.splice(index, 1);
			}else{
                let errorCode = this.getGroupDisabled(obj);
                if(errorCode > 0){
                    let {
                        athlete_enroll_teamgroup_num_max,
                        athlete_enroll_single_or_doublegroup_num_max
                    } = this.enrollOptions;
                    let message;
                    switch(errorCode){
                        case 1:
                            message = `该组别每队限报${obj.GroupSetting.AthletesMax}人`;
                            break;
                        case 2:
                            if(this.form.sex == 1){
                                message = `该组别每队限报${obj.GroupSetting.MaleAthletesMax}名男子`;
                            }else if(this.form.sex == 2){
                                message = `该组别每队限报${obj.GroupSetting.FemaleAthletesMax}名女子`;
                            }
                            break;
                        case 3:
                            message = '该运动员在该组别中被举报，不能报名';
                            break;
                        case 4:
                            message = `该组别每队限报${obj.GroupSetting.AthletesMax}对组合`;
                            break;
                        case 5:
                            message = '必须先报名团体组别，才能报名个人/双人组别';
                            break;
                        case 6:
                            message = '不能同时报名团体组别和个人/双人组别';
                            break;
                        case 7:
                            message = `最多只能同时报名${athlete_enroll_teamgroup_num_max}个团体组别`;
                            break;
                        case 8:
                            message = `最多只能同时报名${athlete_enroll_single_or_doublegroup_num_max}个单人/双人组别`;
                            break;
                        case 9:
                            message = '该队员已在其他代表队中担任运动员';
                            break;
						case 10:
							message = '该组别已报满';
							break;
                    }
                    this.$Toast.warning(message);
                    return;
                }

                let roles = [...this.form.roleValue];
                let isAthlete = roles.some(item=>item.IsAthlete == 1);
                if(isAthlete){
                    groupValue.push({
                        GroupInfo:{
                            Id: obj.GroupSetting.LeagueGroupId,
                            Name: obj.GroupSetting.LeagueGroupName,
                        }
                    });
                }else{
                    let notCanPartTime = roles.find(item=>item.CanPartTime == 0);
                    if(notCanPartTime){
                        let {RoleName} = notCanPartTime;
                        this.$Toast.warning(RoleName+'不能兼报运动员');
                        return;
                    }else{
                        let RoleList = this.roles,
                            len = RoleList.length;
                        groupValue.push({
                            GroupInfo:{
                                Id: obj.GroupSetting.LeagueGroupId,
                                Name: obj.GroupSetting.LeagueGroupName,
                            }
                        });
                        if(RoleList[len - 1].children){
                            let children = RoleList[len - 1].children;
                            roles.push(children[0]);
                        }else{
                            roles.push(RoleList[len - 1]);
                        }
                        this.$set(this.form,'roleValue',roles);
                    }
                }
            }
            
            this.setDataUpdate();
            this.$set(this.form,'groupValue',groupValue);
        },
        getGroupActive(obj){
			return this.form.groupValue.some(item=>item.GroupInfo.Id == obj.GroupSetting.LeagueGroupId);
        },
        getGroupDisabled(obj){
			if(this.isEnrollGroup) return 9;
            if(obj.Impeached) return 3;//被举报
			let isInclude = this.getGroupActive(obj);
			if(!isInclude) { //涉及到多个组别之间交叉关系的判断，只能针对没有被勾中的组别。
                let {
                    athlete_enroll_limit,
                    athlete_enroll_teamgroup_num_max,
                    athlete_enroll_single_or_doublegroup_num_max
                } = this.enrollOptions;
                if(athlete_enroll_limit == 1 && [1, 3].includes(obj.GroupSetting.GroupType)){
                    let isSelectMulti = this.groups.some(item=>item.GroupSetting.GroupType == 2 && this.getGroupActive(item));
                    if(!isSelectMulti){
                        return 5;//必须先报名团体组别，才能报名个人/双人组别
                    }
                }else if(athlete_enroll_limit == 2){
                    let isSelectMulti = this.groups.some(item=>item.GroupSetting.GroupType == 2 && this.getGroupActive(item)),
                        isSelectNotMulti = this.groups.some(item=>[1, 3].includes(item.GroupSetting.GroupType) && this.getGroupActive(item));
                    if([1, 3].includes(obj.GroupSetting.GroupType) && isSelectMulti){
                        return 6;//不能同时报名团体组别和个人/双人组别
                    }else if(obj.GroupSetting.GroupType == 2 && isSelectNotMulti){
                        return 6;//不能同时报名团体组别和个人/双人组别
                    }
                }
                if(obj.GroupSetting.GroupType == 2){
                    if(athlete_enroll_teamgroup_num_max > 0){
                        let filter = this.groups.filter(item=>item.GroupSetting.GroupType == 2 && this.getGroupActive(item));
                        if(filter.length >= athlete_enroll_teamgroup_num_max){
                            return 7;//团体组数量超出
                        }
                    }
                }else{
                    if(athlete_enroll_single_or_doublegroup_num_max > 0){
                        let filter = this.groups.filter(item=>[1, 3].includes(item.GroupSetting.GroupType) && this.getGroupActive(item));
                        if(filter.length >= athlete_enroll_single_or_doublegroup_num_max){
                            return 8;//个人/双打组数量超出
                        }
                    }
                }
            }
            let isOldInclude = this.oldGroupValue.some(item=>item.GroupInfo.Id == obj.GroupSetting.LeagueGroupId);//判断是否在修改前已经报过，组别满员时使用
            if(!isOldInclude){
                if(obj.GroupSetting.GroupType == 3){
                    if(obj.GroupSetting.AthletesMax && obj.EnrollDoublesNum >= obj.GroupSetting.AthletesMax){
                        return 4;//组合满员
                    }
                }else{
                    if(obj.GroupSetting.AthletesMax && obj.EnrollNum >= obj.GroupSetting.AthletesMax){
                        return 1;//满员
                    }else if(this.form.sex == 1 && obj.GroupSetting.MaleAthletesMax && obj.EnrollMaleNum >= obj.GroupSetting.MaleAthletesMax){
                        return 2;//男子满员
                    }else if(this.form.sex == 2 && obj.GroupSetting.FemaleAthletesMax && obj.EnrollFemaleNum >= obj.GroupSetting.FemaleAthletesMax){
                        return 2;//女子满员
                    }
                }
            }
			// let EnrollQuotaStore = obj.GroupSetting.EnrollQuotaStore || {};
			// if(EnrollQuotaStore.TotalNum > 0 && EnrollQuotaStore.LeftNum == 0){
			// 	return 10;//组别已报满，所有报名的代表队、个人
			// }
			return 0;
        },
        uploadImg(type){
            if(this.isEnrollGroup){
                this.$Toast.warning('该队员已在其他代表队中担任运动员');
                return;
            }
            updatePortrait({...this.ossOptions,Menu:0,Resolutions:'1024,768'}).then(data=>{
                if(type == 1){
                    this.form.frontImg = data.Url;
                }else if(type == 2){
                    this.form.behindImg = data.Url;
                }
				this.setDataUpdate();
            })
        },
		showUploadPortraitPhoto(){
            if(this.isEnrollGroup){
                this.$Toast.warning('该队员已在其他代表队中担任运动员');
                return;
            }
			this.$refs.uploadPortraitPhoto.choose().then(ossUrl=>{
				this.form.portraitImg = ossUrl;
				this.setDataUpdate();
			})
		},
        submit(){
            let props = Object.keys(this.rules);
			let form = this.form;
			new formValidator(form, props, this.rules).validate((valid, message, prop)=>{
				if(valid){
					let error = this.verifyExtraForm();
					if(error){
						valid = false;
						message = error.text;
						prop = error.id;
					}
				}
				if(!valid){
					if(prop == 'groupValue'){
						this.selectTab(0);
					}else if(prop == 'roleValue'){
						this.selectTab(1);
					}else{
						this.selectTab(2);
					}
                    this.$Toast.success(message);
                    this.unfoldName = prop;
					this.$nextTick(function(){
                        this.errorUnfold = prop;
                    })
					return;
				}
				let RoleList = form.roleValue.map((item, index)=>({
					"RoleId": item.RoleId,
					"RoleName": item.RoleName,
					"OrderBy": index
				}));
				let GroupList = form.groupValue.map((item, index)=>({
					"Id": item.GroupInfo.Id,
					"Name": item.GroupInfo.Name,
					"OrderNo": index
				}));
				let Extras = this.getExtraForm();
                
                EditDeputationEnrollUser({
                    "DeputationEnrollId": this.memberInfo.DeputationEnrollId,
                    "UserEnrollId": this.memberInfo.UserEnrollId,
					"EnrollBaseInfo": {
						"UserId": this.memberInfo.UserId,
						"Name": this.memberInfo.Name,
						"Phone": form.phone,
						"IdentityType": form.identityType || null,
						"IdentityNo": form.identityNo || null,
						"Gender": form.sex || null,
						"Birthday": form.birthDate || null,
						"JerseyNumber": form.jerseyNumber,
						"IdentityPhoto1": form.frontImg,
						"IdentityPhoto2": form.behindImg,
						"PortraitPhoto": form.portraitImg,
					},
                    "RoleList": RoleList,
                    "GroupList": GroupList,
                    "Extras": Extras
                }).then(data=>{
                    if(data.Code == 0){
                        let groups = data.UnpairGroups || [];
                        if (groups.length > 0){
                            this.$Prompt({
                                title: '保存成功',
                                message: `但因为性别变化，【${groups.map(item=>item.Name).join('、')}】中的配对已经取消。`,
                                confirmText: '我知道了'
                            })
                        }else{
                            this.$Toast.success('保存成功');
                        }
                        this.memberInfoShow = false;
                        this.$emit('save-success');
                    }else if(data.Code == 3883){
                        this.$Prompt({
                            title: '报名限制',
                            message: '该队员已在其他代表队中担任运动员，只能在此担任其他人员，且不能修改其报名信息。',
                            confirmText: '我知道了'
                        })
                    }
                })
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@include uploadImage;
#MemberInfo{
    .dialog{
        width: 100%;
        height: 1134px;
        max-height: 80vh;
    }
    .memberInfo_header{
        min-height: 178px;
        .memberInfo_title{
            height: 102px;
            width: 100%;
            font-size: 32px;
            color: #1B1C1E;
            text-align: center;
            font-weight: 500;
            line-height: 92px;
            padding-top: 10px;
            box-sizing: border-box;
            position: relative;
            img{
                width: 48px;
                height: 48px;
                position: absolute;
                top: 32px;
                right: 32px;
            }
        }
        .memberInfo_tab{
            height: 76px;
            width: 100%;
            margin-bottom: 32px;
            ul{
                display: flex;
                justify-content: space-between;
                li{
                    flex: 1;
                    text-align: center;
                    span{
                        display: inline-block;
                        height: 76px;
                        font-size: 32px;
                        color: #666666;
                        font-weight: 400;
                        line-height: 76px;
                    }
                    &.active{
                        span{
                            color: #1B1C1E;
                            font-weight: 500;
                            position: relative;
                            &::after{
                                content: "";
                                width: 100%;
                                height: 8px;
                                background: #1B1C1E;
                                border-radius: 4px;
                                position: absolute;
                                left: 0;
                                bottom: 0;
                            }
                        }
                    }
					&.new{
						span{
							position: relative;
							&::before{
								content: "";
								width: 38px;
								height: 38px;
								background: url('~@/assets/images/icon/icon_提示_红色_2@2x.png') no-repeat center / 100%;
								position: absolute;
								top: calc(50% - 19px);
								right: -40px;
							}
						}
					}
                }
            }
        }
		.enrollGroup_hint{
			width: 670px;
			height: 108px;
			padding: 20px;
			box-sizing: border-box;
			background: #FCF7F1;
			border-radius: 20px;
			margin: 0 auto;
			margin-bottom: 12px;
			
			font-weight: 400;
			font-size: 24px;
			color: #88919A;
			line-height: 34px;
			span{
				color: #ED8A03;
			}
		}
    }
    .memberInfo_content{
        height: calc(100% - 242px);
        padding: 0 40px;
        padding-bottom: calc(var(--safe-area-inset-bottom) + 150px + 40px);
        box-sizing: border-box;
        overflow-y: auto;
        .memberInfo_role{
            .children{
                .option{
                    display: inline-block;
                    width: calc((100% - 14px) / 2);
                    @include line-height(72px);
                    border-radius: 8px;
                    margin-bottom: 16px;
                    margin-right: 14px;
                    background-image: none;
                    padding-top: 0;
                    padding-bottom: 0;
                    &:nth-of-type(2n){
                        margin-right: 0;
                    }
                }
            }
        }
    }
    .memberInfo_option{
        @include bottom-button;
        position: absolute;
    }
    .memberInfo_basic{
        .extra_select > div{
            display: inline-block;
            width: calc((100% - 18px) / 2);
            margin-right: 18px;
            &:nth-of-type(2n){
                margin-right: 0;
            }
        }
		.realName_hint{
			width: 100%;
			height: 74px;
			padding: 20px;
			box-sizing: border-box;
			background: #FCF7F1;
			border-radius: 20px;
			margin-bottom: 24px;
			
			font-weight: 400;
			font-size: 24px;
			color: #88919A;
			line-height: 34px;
			span{
				color: #ED8A03;
			}
		}
		.phone{
			width: 100%;
			height: 120px;
			background: #F6F6F6;
			border-radius: 20px;
			padding: 0 40px;
			box-sizing: border-box;
			margin-bottom: 24px;
			
			display: flex;
			align-items: center;
			justify-content: space-between;
			.content{
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				color: #1B1C1E;
				line-height: 44px;
				.label{
					font-weight: 500;
					font-size: 32px;
					margin-right: 16px;
				}
				.text{
					font-weight: 400;
					font-size: 28px;
				}
			}
            button{
                width: 104px;
				height: 56px;
                line-height: 56px;
                font-size: 28px;
                color: #FFFFFF;
                font-weight: 500;
                text-align: center;
                background: #1B1C1E;
                border-radius: 28px;
            }
		}
        .upload_images_title{
            margin-top: 40px;
        }
        .upload_images{
            display: flex;
            .front,
            .behind{
                width: 261px;
                height: 196px;
                --center-size: 82px;
                --corner-size: 60px;
                .default{
                    --width: 190px;
                    --height: 116px;
                }
            }
            .front{
                margin-right: 56px;
            }
            .portrait{
                width: 240px;
                min-height: 240px;
                --center-size: 82px;
                --corner-size: 60px;
                .default{
                    --width: 120px;
                    --height: 160px;
                }
                .image{
                    height: auto;
                }
            }
        }
    }
}
</style>
<style lang="scss">
    
#MemberInfo #date_container{
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 910;
    background: rgba(0,0,0,0.40);
    .date_container_content{
        width: auto;
        height: auto;
        background: #FFFFFF;
        box-shadow: 0px 36px 64px -8px rgba(136,136,136,0.25);
        border-radius: 20px;
        overflow: hidden;
        margin-top: 10%;
    }
    .date_content{
        width: auto;
        height: auto;
        font-size: 28px;
        .layui-laydate{
            width: auto;
            height: auto;
            font-size: 28px;
            color: #1B1C1E;
            font-weight: 400;
            box-shadow: none;
            border: none;
            .layui-laydate-main {
                width: auto;
            }
        }
        .layui-laydate-header{
            width: 100%;
            height: 100px;
            font-size: 32px;
            color: #7AD21A;
            line-height: 48px;
            font-weight: 700;
            display: flex;
            align-items: center;
            padding: 15px 30px 5px;
            .laydate-set-ym{
                padding: 0 15px;
            }
            i{
                position: static;
                font-size: 32px;
                padding: 0 15px;
                color: #7AD21A;
            }
            i:hover,
            span:hover{
                color: inherit;
            }
        }
        .layui-laydate-content{
            padding: 15px 30px;
            td,th{
                width: 80px;
                height: 70px;
                border-radius: 8px;
            }
            td.layui-this{
                color: #FFFFFF;
                font-weight: 700;
                background: #7AD21A !important;
            }
        }
        .layui-laydate-list{
            padding: 25px 30px;
            li{
                width: 33%;
                @include line-height(85px);
                border-radius: 8px;
                &.layui-this {
                    background: #7AD21A !important;
                }
            }
        }
        .laydate-month-list>li{
            @include line-height(90px);
            margin: 0.15rem 0 !important;
        }
    }
    .operation{
        height:90px;
        width: 100%;
        display: flex;
        border-top: 1px #EFEFEF solid;
        button{
            flex: 1;
            @include line-height(90px);
            font-size: 28px;
            color: #3A3F49;
            text-align: center;
            font-weight: 500;
            border-right: 1px #EFEFEF solid;
            &:last-of-type{
                color: #7AD21A;
                border-right: none;
            }
        }
    }
}
</style>